export function LogoMark({ className = "h-10 w-10" }) {
    return (
        <img
            src="/images/logo-mark.jpg"
            alt=""
            aria-hidden="true"
            className={`shrink-0 object-cover ${className}`}
        />
    );
}

export default function Logo({ dark = false, className = "" }) {
    return (
        <span className={`flex items-center gap-3 ${className}`}>
            <LogoMark className="h-11 w-11" />
            <span className="flex flex-col justify-center leading-none">
                <span className={`text-[17px] font-bold tracking-tight ${dark ? "text-white" : "text-navy"}`}>
                    UNIMICRON
                </span>
                <span className={`mt-1 font-mono text-[9px] font-medium uppercase tracking-[0.28em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
                    Technology India
                </span>
            </span>
        </span>
    );
}
